/** Existing API contract: HTTP 409 with "Report … is not ready (status=…)". */
export class PnlReportStatusError extends Error {
  readonly reportStatus?: 'GENERATING' | 'FAILED' | 'DELETED';
  constructor(message: string) {
    super(message);
    this.name = 'PnlReportStatusError';
    const status = /\(status=(GENERATING|FAILED|DELETED)\)/.exec(message)?.[1];
    if (status === 'GENERATING' || status === 'FAILED' || status === 'DELETED') this.reportStatus = status;
  }
}
